import { fmtBRL, fmtDate } from "./format";

export const waPhone = (raw) => {
  const d = (raw || "").replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("55") && d.length >= 12) return d;
  if (d.length === 10 || d.length === 11) return `55${d}`;
  return d;
};

export const openWhatsApp = (phone, message) => {
  const p = waPhone(phone);
  const url = p
    ? `https://wa.me/${p}?text=${encodeURIComponent(message)}`
    : `https://wa.me/?text=${encodeURIComponent(message)}`;
  const win = window.open(url, "_blank", "noopener");
  return !!win;
};

export const receiptMessage = ({ clientName, date, amount, method, orders = [], leftoverCredit = 0, balanceAfter = null }) => {
  const lines = [
    "*RECIBO DE PAGAMENTO*",
    "",
    `Cliente: ${(clientName || "—").trim()}`,
    `Data: ${fmtDate(date)}`,
    `Valor pago: ${fmtBRL(amount)}${method ? ` (${method})` : ""}`,
  ];
  const applied = orders.filter((o) => o.order_code);
  if (applied.length) {
    lines.push("", "Aplicado em:");
    applied.forEach((o) => lines.push(`• Pedido #${o.order_code} — ${fmtBRL(o.amount)}`));
  }
  if ((leftoverCredit || 0) > 0.009) lines.push("", `Sobra convertida em crédito: ${fmtBRL(leftoverCredit)}`);
  if (balanceAfter != null) lines.push("", `Saldo devedor atual: ${fmtBRL(balanceAfter)}`);
  lines.push("", "Obrigado pela preferência!");
  return lines.join("\n");
};
